// src/components/GuideCard/SkeletonCard.jsx
import React from 'react';

// Mirrors GuideCard: inset thumb, title lines, footer row.
const SkeletonCard = ({ cardIndex = 0 }) => (
  <article
    data-testid="skeleton-card"
    className="guide-tile guide-tile--skeleton"
    style={{ '--card-index': cardIndex }}
    aria-hidden="true"
  >
    <div className="guide-tile__thumb">
      <div className="skeleton" style={{ width: '100%', height: '100%' }} />
    </div>
    <div className="guide-tile__body">
      <div className="skeleton skeleton--title" />
      <div className="skeleton skeleton--line" />
      <div className="skeleton skeleton--line skeleton--line-short" />
    </div>
    <div className="guide-tile__meta">
      <div className="skeleton skeleton--badge" style={{ width: '56px', height: '22px' }} />
      <div className="skeleton" style={{ width: '48px', height: '11px', marginLeft: 'auto' }} />
    </div>
  </article>
);

export default SkeletonCard;
